import { createFileRoute, useRouter } from "@tanstack/react-router"
import { Button, OnboardingWrapper, Separator } from "toptaal-shared"

export const Route = createFileRoute("/auth/failed_sso/")({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()

  const handleNavigate = () => {
    router.navigate({ to: "/login" })
  }

  return (
    <OnboardingWrapper title="Inloggen mislukt">
      <p className="text-center -mt-8">
        Inloggen mislukt. Je kunt alleen inloggen met een Microsoft account van
        TopTaal.
      </p>

      <Separator className="my-8" />

      <Button
        variant="ghost"
        className="flex mx-auto mt-10"
        onClick={handleNavigate}
      >
        Inloggen
      </Button>
    </OnboardingWrapper>
  )
}
